import { config } from "./config";
// import { useTitleStore  } from "../stores/title.js";
/* global gapi */
/* global google */

let intializeGapiClientPromise = null;
function intializeGapiClient() {
  return intializeGapiClientPromise || (intializeGapiClientPromise = new Promise((resolve, reject) => {
    gapi.load('client', () => {
      gapi.client.init({
        apiKey: config.API_KEY,
        discoveryDocs: [config.DISCOVERY_DOC],
      }).then(() => {
        resolve();
      }, (error) => {
        console.log('intializeGapiClient:error', error);
        reject(error);
      })
    })
  }))
}

async function intializeTokenClient(callback) {
  try {
    await intializeGapiClient();
  
    const tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: config.CLIENT_ID,
      scope: config.SCOPES,
      callback: () => {
        callback();
      }
    })
  
    if (gapi.client.getToken() === null) {
      // Prompt the user to select a Google Account and ask for consent to share their data
      // when establishing a new session.
      tokenClient.requestAccessToken({prompt: 'consent'});
    } else {
      // Skip display of account chooser and consent dialog for an existing session.
      // tokenClient.requestAccessToken({prompt: ''});
      callback();
    }
  } catch (error) {
    console.log('intializeTokenClient:error', error);
  }
}

function initCodeClient() {
  return google.accounts.oauth2.initCodeClient({
    client_id: config.CLIENT_ID,
    scope: config.SCOPES,
    ux_mode: 'redirect',
    redirect_uri: "https://www.livepolls.app/video_downloader/drive/auth",
    state: ""
  })
}

function initTokenClient() {

  console.log(config.CLIENT_ID,"客户端id")
  console.log(config.SCOPES,"scpe")

  return new Promise((resolve, reject) => {
    const initToken = () => {
      const client = google.accounts.oauth2.initTokenClient({
        client_id: config.CLIENT_ID,
        scope: config.SCOPES,
        prompt: 'select_account',
        callback: function (res) {
          console.log('initTokenClient', res);
          // 我修改了下面这个 indexof权限.file 后面加上
          if (res.access_token && res.scope.indexOf('/auth/drive') != -1) {
            res.create_time = new Date().getTime();
            localStorage.setItem('cache_client', JSON.stringify(res));
            console.log(res,"执行到 返回res了")
            resolve(res);
          } else {
            resolve({});
          }
        }
      })

      client.requestAccessToken();
    }

    let token = localStorage.getItem('cache_client');
    console.log('token', token);
    if (token) {
      token = JSON.parse(token);
      if (token.create_time + token.expires_in * 1000 > new Date().getTime()) {
        resolve(token);
      } else {
        initToken();
      }
    } else {
      initToken();
    }
  })
}

function getResumableSessionURI(metadata, token, mimeType) {
  const bodyData = JSON.stringify(metadata);
  return fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=resumable', {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + token, 
      'X-Upload-Content-Type': mimeType,
      'Content-Type': 'application/json; charset=UTF-8',
      'Content-Length': new Blob([bodyData], {type: 'application/json'}).size
    },
    body: bodyData
  })
}

function uploadDriveResumable(url, blob, fileSize, i) {
  const chunkSize = 256 * 1024;
  return fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Length': blob.size,
      'Content-Range': `bytes ${i * chunkSize}-${Math.min((i + 1) * chunkSize, fileSize) - 1}/${fileSize}`
    },
    body: blob
  })
  // .then(res => res.json())
}

function uploadToDrive(metadata, blob, token) {
  let form = new FormData();
  form.append('metadata', new Blob([JSON.stringify(metadata)], {type: 'application/json'}));
  form.append('file', blob);
  return fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart', {
    method: 'POST',
    headers: new Headers({'Authorization': 'Bearer ' + token}),
    body: form
  })
  .then(res => res.json())
  .catch(error => {
    return Promise.reject(error);
  })
  // .then(res => {
  //   const title = useTitleStore();
  //   title.title = 'Saved to Google Drive!';
  //   // console.log('uploadToDrive', res);
  //   return Promise.resolve(res);
  // })
}

const folder_name = 'mindmap';
function createFolder(token) {
  const fileMetadata = {
    name: folder_name,
    mimeType: 'application/vnd.google-apps.folder',
  }
  let form = new FormData();
  form.append('metadata', new Blob([JSON.stringify(fileMetadata)], {type: 'application/json'}));
  return fetch('https://www.googleapis.com/upload/drive/v3/files', {
    method: 'POST',
    headers: new Headers({'Authorization': 'Bearer ' + token}),
    body: form
  })
  .then(res => res.json())
  .catch(error => {
    return Promise.reject(error);
  })
}

function getFolder(token) {
  return fetch(`https://www.googleapis.com/drive/v3/files?q=name='${folder_name}'`, {
    method: 'GET',
    headers: new Headers({'Authorization': 'Bearer ' + token}),
  })
  .then(res => res.json())
  .catch(error => {
    return Promise.reject(error);
  })
}

function deleteDriveFile(fileId) {
  fetch(`https://www.googleapis.com/drive/v3/files/${fileId}`, {
    method: 'DELETE'
  })
}

function showPicker(accessToken, pickerCallback) {
  const docsView = new google.picker.DocsView()
      .setIncludeFolders(true) 
      .setMimeTypes('application/vnd.google-apps.folder')
      .setSelectFolderEnabled(true);
  const picker = new google.picker.PickerBuilder()
      .addView(docsView)
      .setOAuthToken(accessToken)
      .setDeveloperKey(config.API_KEY)
      .setTitle('Select Target Folder')
      .setCallback(pickerCallback)
      .build();
  picker.setVisible(true);
} 


function getDriveFileMetadata(fileId, token) {
  return fetch(`https://www.googleapis.com/drive/v3/files/${fileId}`, {
    headers: new Headers({'Authorization': 'Bearer ' + token}),
  })
  .then(res => res.json())
}


function downloadDriveFile(fileId, token, mimeType) {
  return fetch(`https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`, {
    headers: new Headers({'Authorization': 'Bearer ' + token}),
  })
  .then((response) => response.body)
  .then((rb) => {
    const reader = rb.getReader();
    return new ReadableStream({
      start(controller) {
        function push() {
          reader.read().then(({ done, value }) => {
            console.log('done', done);
            if (done) {
              controller.close();
              return;
            }
            controller.enqueue(value);
            push();
          })
        }
        push();
      },
    })
  })
  .then((stream) =>
    new Response(stream, { headers: { 'Content-Type': mimeType } }).blob()
  )
}


export {downloadDriveFile, intializeTokenClient, initCodeClient, getDriveFileMetadata,initTokenClient, getResumableSessionURI, uploadDriveResumable, uploadToDrive, createFolder, getFolder, deleteDriveFile, showPicker };